import styled from "styled-components";
import { Flex, Box } from "grid-styled";
import * as colors from "../settings/colors";

const Panel = styled(Box)`
  border: 1px solid ${colors.DIVIDER};
  border-radius: 4px;
`;

const PanelHeader = styled(Flex).attrs({
  py: props => props.py || 1,
  px: props => props.px || 2,
  align: props => props.align || "center"
})`
  font-weight: 600;
  background: ${colors.TABLE_HEADER_BG};
  border-radius: 4px 4px 0 0;
  line-height: 24px;
`;

const PanelBody = styled(Box).attrs({
  p: props => props.p || 2
})`
  & *:first-child {
    margin-top: 0;
  }

  & *:last-child {
    margin-bottom: 0;
  }
`;

export default Panel;
export { Panel, PanelHeader, PanelBody };



// WEBPACK FOOTER //
// ./src/components/Panel.js